import * as API from '../api'
export const FETCH_INTERACTIONTYPE = 'FETCH_INTERACTIONTYPE'
export const FETCHING_INTERACTIONTYPE = 'FETCHING_INTERACTIONTYPE'
export const FETCH_INTERACTIONTYPE_ERROR = 'FETCH_INTERACTIONTYPE_ERROR'
export const FETCH_INTERACTIONSTYPE = 'FETCH_INTERACTIONSTYPE'
export const FETCHING_INTERACTIONSTYPE = 'FETCHING_INTERACTIONSTYPE'
export const FETCH_INTERACTIONSTYPE_ERROR = 'FETCH_INTERACTIONSTYPE_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_INTERACTIONTYPE = 'CHANGE_INTERACTIONTYPE'
export const DELETE_INTERACTIONTYPE = 'DELETE_INTERACTIONTYPE'
export const ADD_INTERACTIONTYPE = 'ADD_INTERACTIONTYPE'
export const EDIT_INTERACTIONTYPE = 'EDIT_INTERACTIONTYPE'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_INTERACTIONTYPE = 'NEW_FORM_INTERACTIONTYPE'
export const INTERACTIONTYPE_FORM_ERROR = 'INTERACTIONTYPE_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'
export const OPEN_LOGS_MODAL = 'OPEN_LOGS_MODAL'
export const CLOSE_LOGS_MODAL = 'CLOSE_LOGS_MODAL'
export const FETCHING_LOGS = 'FETCHING_LOGS'
export const FETCH_LOGS = 'FETCH_LOGS'
export const FETCH_LOGS_ERROR = 'FETCH_LOGS_ERROR'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const openLogsModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_LOGS_MODAL })
  }
}

export const closeLogsModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_LOGS_MODAL })
  }
}

export const handleChangeInteractionType = interactionType => {
  return dispatch => {
    dispatch({ type: CHANGE_INTERACTIONTYPE, interactionType })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const handleInteractionTypeError = (res, dispatch) => {
  const { data: errorMessage = '' } = res

  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: INTERACTIONTYPE_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newFormInteractionType = interactionType => {
  return dispatch => {
    dispatch({ type: NEW_FORM_INTERACTIONTYPE })
  }
}

export const setInteractionTypeFormTouched = interactionType => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreInteractionType = id => {
  return dispatch => {
    dispatch({ type: FETCHING_INTERACTIONSTYPE })
    return API.interactionsType
      .restoreInteractionType(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_INTERACTIONTYPE, interactionType: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_INTERACTIONSTYPE_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleInteractionTypeError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchInteractionsType = options => {
  return dispatch => {
    dispatch({ type: FETCHING_INTERACTIONSTYPE })
    return API.interactionsType
      .getInteractionsType(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_INTERACTIONSTYPE,
          interactionsType: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_INTERACTIONSTYPE_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const deleteInteractionType = id => {
  return dispatch => {
    dispatch({ type: FETCHING_INTERACTIONSTYPE })
    return API.interactionsType
      .deleteInteractionType(id)
      .then(({ data: interactionType }) => {
        dispatch({ type: DELETE_INTERACTIONTYPE, interactionType })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_INTERACTIONSTYPE_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addInteractionType = interactionType => {
  return dispatch => {
    dispatch({ type: FETCHING_INTERACTIONSTYPE })
    dispatch({ type: FETCHING_INTERACTIONTYPE })
    return API.interactionsType
      .addInteractionType(interactionType)
      .then(({ data }) => {
        dispatch({ type: ADD_INTERACTIONTYPE, interactionType: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleInteractionTypeError(response, dispatch)
        dispatch({
          type: FETCH_INTERACTIONSTYPE_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editInteractionType = interactionType => {
  return dispatch => {
    dispatch({ type: FETCHING_INTERACTIONSTYPE })
    dispatch({ type: FETCHING_INTERACTIONTYPE })
    return API.interactionsType
      .editInteractionType(interactionType)
      .then(({ data }) => {
        dispatch({ type: EDIT_INTERACTIONTYPE, interactionType: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_INTERACTIONSTYPE_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleInteractionTypeError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchInteractionType = id => {
  return dispatch => {
    dispatch({ type: FETCHING_INTERACTIONTYPE, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.interactionsType
      .getInteractionType(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_INTERACTIONTYPE, interactionType: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_INTERACTIONTYPE_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const fetchLogs = id => {
  return dispatch => {
    dispatch({ type: FETCHING_LOGS })
    return API.interactionsType
      .getLogs(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_LOGS, logs: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_INTERACTIONTYPE_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/interactionsType.js